import { render, staticRenderFns } from "./SplashLoader.vue?vue&type=template&id=f8922090&scoped=true&"
import script from "./SplashLoader.vue?vue&type=script&lang=js&"
export * from "./SplashLoader.vue?vue&type=script&lang=js&"
import style0 from "./SplashLoader.vue?vue&type=style&index=0&id=f8922090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8922090",
  null
  
)

export default component.exports